import { render } from "./FinancialAccountDetailHistoryTab.vue?vue&type=template&id=db7caa22"
import script from "./FinancialAccountDetailHistoryTab.vue?vue&type=script&lang=js"
export * from "./FinancialAccountDetailHistoryTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__